/**
 * This function returns the youtube thumbnail image url.
 */
export const getYoutubeThumbnail = (youtubeUrlId: string): string => {
  return `https://img.youtube.com/vi/${youtubeUrlId}/sddefault.jpg`
}
